// Antes era un objeto estático en español. Ahora es una función que recibe
// "t" (de useTranslation en el componente que la usa, ya que un módulo
// plano no puede llamar hooks de React) para devolver las mismas
// etiquetas/mensajes ya traducidos según el idioma activo.
export function getStandarInputsData(t) {
  return {
    correo: {
      campo: 1,
      etiqueta: t("camposFormulario.correo.etiqueta"),
      iDCampo: "correo",
      longitud: 100,
      tipoCampo: "text",
      validacion: "Requerido",
      valor: "",
      anchoCampo: "s12 m4 l4",
      order: 7,
      observacion: t("camposFormulario.correo.validacion"),
      errorMessage: t("camposFormulario.correo.validacion"),
      regex: "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$",
      sanitizeRegex: "[^a-zA-Z0-9._%+@-]",
    },
    nombres: {
      campo: 2,
      etiqueta: t("camposFormulario.nombres.etiqueta"),
      iDCampo: "nombres",
      longitud: 100,
      observacion: t("camposFormulario.campoRequeridoGenerico"),
      tipoCampo: "text",
      validacion: "Requerido",
      valor: "",
      anchoCampo: "s12 m6 l6",
      order: 1,
    },
    apellidos: {
      campo: 3,
      etiqueta: t("camposFormulario.apellidos.etiqueta"),
      iDCampo: "apellidos",
      longitud: 100,
      observacion: t("camposFormulario.campoRequeridoGenerico"),
      tipoCampo: "text",
      validacion: "Requerido",
      valor: "",
      anchoCampo: "s12 m6 l6",
      order: 2,
    },
    apellidoMaterno: {
      campo: 3,
      etiqueta: t("camposFormulario.apellidoMaterno.etiqueta"),
      iDCampo: "apellidoMaterno",
      longitud: 100,
      observacion: t("camposFormulario.campoRequeridoGenerico"),
      tipoCampo: "text",
      validacion: "Requerido",
      valor: "",
      anchoCampo: "s12 m3 l3",
      order: 4,
    },
    apellidoPaterno: {
      campo: 3,
      etiqueta: t("camposFormulario.apellidoPaterno.etiqueta"),
      iDCampo: "apellidoPaterno",
      longitud: 100,
      observacion: t("camposFormulario.campoRequeridoGenerico"),
      tipoCampo: "text",
      validacion: "Requerido",
      valor: "",
      anchoCampo: "s12 m3 l3",
      order: 3,
    },
    telefono: {
      campo: 4,
      etiqueta: t("camposFormulario.telefono.etiqueta"),
      iDCampo: "telefono",
      longitud: 100,
      observacion: t("camposFormulario.telefono.validacion"),
      tipoCampo: "text",
      validacion: "Requerido",
      valor: "",
      anchoCampo: "s12 m4 l4",
      order: 8,
      errorMessage: t("camposFormulario.telefono.validacion"),
      regex: "^[0-9]{10,15}$",
      sanitizeRegex: "[^0-9]",
    },
    fechaNacimiento: {
      campo: 5,
      etiqueta: t("camposFormulario.fechaNacimiento.etiqueta"),
      iDCampo: "fechaNacimiento",
      longitud: 100,
      observacion: t("camposFormulario.fechaNacimiento.observacion"),
      tipoCampo: "date",
      validacion: "Requerido",
      valor: "",
      anchoCampo: "s12 m4 l4",
      order: 6,
      min: "1930-01-01",
      errorMessage: t("camposFormulario.fechaNacimiento.errorMessage"),
      regex:
        "^(19[3-9][0-9]|20[0-9][0-9])-(0[1-9]|1[0-2])-(0[1-9]|1[0-9]|2[0-9]|3[0-1])$",
    },
    genero: {
      campo: 6,
      etiqueta: t("camposFormulario.genero.etiqueta"),
      iDCampo: "genero",
      longitud: 100,
      observacion: t("camposFormulario.campoRequeridoGenerico"),
      tipoCampo: "Select",
      validacion: "Requerido",
      selectLabel: t("camposFormulario.genero.selectLabel"),
      order: 5,
      valor: [
        {
          texto: t("camposFormulario.genero.femenino"),
          valor: "F",
        },
        {
          texto: t("camposFormulario.genero.masculino"),
          valor: "M",
        },
      ],
      anchoCampo: "s12 m4 l4",
    },
  };
}
